import { ListRow } from "./ListRow";
import React from "react";

export const LoanTypeList = ({
  quotes,
  armFixedTermYears,
  loanTerm,
  isComparedIds,
  setComparedId,
  setDetails,
}) => {
  const getProgress = (values, currentValue) => {
    const minValue = Math.min(...values);
    const maxValue = Math.max(...values);

    // Do not allow division by zero
    if (maxValue === minValue) {
      return 0;
    }

    return 10 + ((maxValue - currentValue) / (maxValue - minValue)) * 90;
  };

  return (
    <>
      <div className="thirty-year-fixed-heading bold">
        {!armFixedTermYears
          ? `${loanTerm} Year Fixed`
          : `${armFixedTermYears}/6 Adjustable Rate`}
      </div>
      <div className="list-rows-wrapper">
        <div className="list-header-row">
          <div className="list-header-cell first-list-cell">Rate</div>
          <div className="list-header-cell">Monthly Payment</div>
          <div className="list-header-cell">Lender Cost</div>
          <div className="list-header-cell">APR</div>
          <div className="list-header-cell centered">View Details</div>
          <div className="list-header-cell centered">Compare</div>
        </div>
        {quotes.map((quote) => {
          // Calculate progress values for each quote
          const rateProgress = getProgress(
            quotes.map((quote) => quote.rate),
            quote.rate
          );
          const aprProgress = getProgress(
            quotes.map((quote) => quote.apr),
            quote.apr
          );
          const monthlyProgress = getProgress(
            quotes.map((quote) => quote.monthlyPayment),
            quote.monthlyPayment
          );
          const closingProgress = getProgress(
            quotes.map((quote) => quote.closingCosts),
            quote.closingCosts
          );

          return (
            <ListRow
              quote={quote}
              id={quote.id}
              key={quote.id}
              isComparedIds={isComparedIds}
              setComparedId={setComparedId}
              rateProgress={rateProgress}
              aprProgress={aprProgress}
              monthlyProgress={monthlyProgress}
              closingProgress={closingProgress}
              setDetails={setDetails}
            />
          );
        })}
      </div>
    </>
  );
};
